import moment from 'moment-timezone';
import { getPlatformAndCardCharges } from 'helpers/getPlatformAndCardCharges';
import { ORDER_PAYMENT_TYPE } from 'helpers/enums';

const getItemCustomizedPrice = (
  itemObj,
  sizeObj,
  halfHalfAdditionalCharges
) => {
  let itemPrice = 0;
  let quantity = 0;
  let halfQuantity = 0;
  let extraPrice = 0;
  let extraPriceHalf = 0;
  let currentItem = JSON.parse(JSON.stringify(itemObj));
  if (!currentItem.itemType || currentItem.itemType === 0) {
    currentItem.selectedSizes &&
      currentItem.selectedSizes.map((item) => {
        if (item._id === sizeObj._id) {
          if (item.quantity > 0) {
            quantity = quantity + item.quantity;
            itemPrice = itemPrice + item.quantity * Number(item.price);
          }
          if (item.variants) {
            item.variants.map((v) => {
              if (v.quantity && Number(v.quantity) > 0)
                itemPrice = itemPrice + item.quantity * Number(v.price);
              return v;
            });
          }
        }
        return item;
      });
    if (quantity > 0) {
      currentItem.selectedExtraIngredients &&
        currentItem.selectedExtraIngredients.map((item, index) => {
          if (item.quantity > 0) {
            extraPrice =
              extraPrice + Number(item.quantity) * Number(item.price);
          }
          return item;
        });
      itemPrice = extraPrice * quantity + itemPrice;
    }
  } else {
    currentItem.selectedModifiers &&
      currentItem.selectedModifiers.map((m) => {
        m.subModifiers.map((s) => {
          if (m._id === currentItem.baseModifierId) {
            quantity = s.quantity;
            itemPrice = itemPrice + Number(s.quantity) * Number(s.price);
            if (s.variants) {
              s.variants.map((v) => {
                itemPrice = itemPrice + Number(v.quantity) * Number(v.price);
              });
            }
          } else {
            if (s.prices) {
              s.prices.map((p) => {
                itemPrice = itemPrice + Number(p.quantity) * Number(p.price);
                if (p.variants) {
                  p.variants.map((v) => {
                    itemPrice =
                      itemPrice + Number(v.quantity) * Number(v.price);
                  });
                }
              });
            }
          }
        });
      });
    if (quantity > 0) {
      currentItem.selectedExtraIngredients &&
        currentItem.selectedExtraIngredients.map((item) => {
          if (item.quantity > 0) {
            extraPrice =
              extraPrice + Number(item.quantity) * Number(item.price);
          }
          return item;
        });
      itemPrice = extraPrice * quantity + itemPrice;
    }
  }
  if (
    currentItem.isHalf &&
    (!currentItem.itemTypeHalf || currentItem.itemTypeHalf === 0)
  ) {
    currentItem.selectedSizesHalf &&
      currentItem.selectedSizesHalf.map((item) => {
        if (item.quantity > 0) {
          halfQuantity = halfQuantity + item.quantity;
          itemPrice = itemPrice + item.quantity * Number(item.price);
        }
        if (item.variants) {
          item.variants.map((v) => {
            if (v.quantity && Number(v.quantity) > 0)
              itemPrice = itemPrice + item.quantity * Number(v.price);
            return v;
          });
        }
        return item;
      });
    if (halfQuantity > 0) {
      currentItem.selectedExtraIngredientsHalf &&
        currentItem.selectedExtraIngredientsHalf.map((item) => {
          if (item.quantity > 0) {
            extraPriceHalf = extraPriceHalf + item.quantity * item.price;
          }
          return item;
        });
      itemPrice = extraPriceHalf * halfQuantity + itemPrice;
    }
  } else if (currentItem.isHalf && currentItem.itemTypeHalf === 1) {
    currentItem.selectedModifiersHalf &&
      currentItem.selectedModifiersHalf.map((m) => {
        m.subModifiers.map((s) => {
          if (m._id === currentItem.baseModifierIdHalf) {
            halfQuantity = s.quantity;
            itemPrice = itemPrice + Number(s.quantity) * Number(s.price);
            if (s.variants) {
              s.variants.map((v) => {
                itemPrice = itemPrice + Number(v.quantity) * Number(v.price);
              });
            }
          } else {
            if (s.prices) {
              s.prices.map((p) => {
                itemPrice = itemPrice + Number(p.quantity) * Number(p.price);
                if (p.variants) {
                  p.variants.map((v) => {
                    itemPrice =
                      itemPrice + Number(v.quantity) * Number(v.price);
                  });
                }
              });
            }
          }
        });
      });
    if (halfQuantity > 0) {
      currentItem.selectedExtraIngredientsHalf &&
        currentItem.selectedExtraIngredientsHalf.map((item) => {
          if (item.quantity > 0) {
            extraPriceHalf = extraPriceHalf + item.quantity * item.price;
          }
          return item;
        });
      itemPrice = extraPriceHalf * halfQuantity + itemPrice;
    }
  }
  if (currentItem.isHalf)
    itemPrice =
      itemPrice + halfHalfAdditionalCharges * (quantity + halfQuantity);
  return itemPrice.toFixed(2);
};

const getItemCustomizedPriceOnly = (
  itemObj,
  sizeObj,
  halfHalfAdditionalCharges
) => {
  let itemPrice = 0;
  let quantity = 0;
  let halfQuantity = 0;
  let currentItem = JSON.parse(JSON.stringify(itemObj));
  if (!currentItem.itemType || currentItem.itemType === 0) {
    currentItem.selectedSizes &&
      currentItem.selectedSizes.map((item) => {
        if (item._id === sizeObj._id) {
          if (item.quantity > 0) {
            quantity = quantity + item.quantity;
            itemPrice = itemPrice + item.quantity * Number(item.price);
          }
          if (item.variants) {
            item.variants.map((v) => {
              if (v.quantity && Number(v.quantity) > 0)
                itemPrice = itemPrice + item.quantity * Number(v.price);
              return v;
            });
          }
        }
        return item;
      });
  } else {
    currentItem.selectedModifiers &&
      currentItem.selectedModifiers.map((m) => {
        m.subModifiers.map((s) => {
          if (m._id === currentItem.baseModifierId) {
            quantity = s.quantity;
            itemPrice = itemPrice + Number(s.quantity) * Number(s.price);
            if (s.variants) {
              s.variants.map((v) => {
                itemPrice = itemPrice + Number(v.quantity) * Number(v.price);
              });
            }
          } else {
            if (s.prices) {
              s.prices.map((p) => {
                itemPrice = itemPrice + Number(p.quantity) * Number(p.price);
                if (p.variants) {
                  p.variants.map((v) => {
                    itemPrice =
                      itemPrice + Number(v.quantity) * Number(v.price);
                  });
                }
              });
            }
          }
        });
      });
  }
  if (
    currentItem.isHalf &&
    (!currentItem.itemTypeHalf || currentItem.itemTypeHalf === 0)
  ) {
    currentItem.selectedSizesHalf &&
      currentItem.selectedSizesHalf.map((item) => {
        if (item.quantity > 0) {
          halfQuantity = halfQuantity + item.quantity;
          itemPrice = itemPrice + item.quantity * Number(item.price);
        }
        if (item.variants) {
          item.variants.map((v) => {
            if (v.quantity && Number(v.quantity) > 0)
              itemPrice = itemPrice + item.quantity * Number(v.price);
            return v;
          });
        }
        return item;
      });
  } else if (currentItem.isHalf && currentItem.itemTypeHalf === 1) {
    currentItem.selectedModifiersHalf &&
      currentItem.selectedModifiersHalf.map((m) => {
        m.subModifiers.map((s) => {
          if (m._id === currentItem.baseModifierIdHalf) {
            halfQuantity = s.quantity;
            itemPrice = itemPrice + Number(s.quantity) * Number(s.price);
            if (s.variants) {
              s.variants.map((v) => {
                itemPrice = itemPrice + Number(v.quantity) * Number(v.price);
              });
            }
          } else {
            if (s.prices) {
              s.prices.map((p) => {
                itemPrice = itemPrice + Number(p.quantity) * Number(p.price);
                if (p.variants) {
                  p.variants.map((v) => {
                    itemPrice =
                      itemPrice + Number(v.quantity) * Number(v.price);
                  });
                }
              });
            }
          }
        });
      });
  }
  if (currentItem.isHalf)
    itemPrice =
      itemPrice + halfHalfAdditionalCharges * (quantity + halfQuantity);
  return itemPrice.toFixed(2);
};

const getExtraPrices = (storeConfig, item, size) => {
  let html = `<br>`;
  item.selectedExtraIngredients &&
    item.selectedExtraIngredients.forEach((ingredient) => {
      html =
        html +
        `${storeConfig.currency}${Number(
          Number(ingredient.price) *
            Number(ingredient.quantity) *
            Number(size.quantity)
        ).toFixed(2)} <br>`;
    });
  return html;
};

const getExtraPricesForHalf = (storeConfig, item, size) => {
  let html = ``;
  if (
    item.selectedExtraIngredients &&
    item.selectedExtraIngredients?.length > 0
  ) {
    item.selectedExtraIngredients.forEach((ingredient) => {
      html =
        html +
        `${storeConfig.currency}${(
          Number(ingredient.price) *
          Number(ingredient.quantity) *
          Number(size.quantity)
        ).toFixed(2)}<br><br>`;
    });
  }

  if (
    item.selectedExtraIngredientsHalf &&
    item.selectedExtraIngredientsHalf?.length > 0
  ) {
    item.selectedExtraIngredientsHalf.forEach((ingredient) => {
      html =
        html +
        `${storeConfig.currency}${(
          Number(ingredient.price) *
          Number(ingredient.quantity) *
          Number(size.quantity)
        ).toFixed(2)}<br>`;
    });
  }
  return html;
};

const getItemGroupingsForReviewOrder = (currentOrder) => {
  let selectedOrder = JSON.parse(JSON.stringify(currentOrder));
  let items = [];
  if (selectedOrder && selectedOrder.menuItems) {
    selectedOrder.menuItems.map((item) => {
      if (item.isHalf) {
        let betterHalfs = currentOrder.menuItems.filter((obj) => {
          return obj.halfIndex === item.halfIndex && obj._id !== item._id;
        });
        let xBetterHalf = items.filter((obj) => {
          return obj._idHalf === item._id;
        });
        if (
          betterHalfs &&
          betterHalfs?.length > 0 &&
          xBetterHalf?.length === 0
        ) {
          item.urlHalf = betterHalfs[0].urlS3;
          item._idHalf = betterHalfs[0]._id;
          item.nameHalf = betterHalfs[0].name;
          item.itemTypeHalf = betterHalfs[0].itemType;
          item.baseModifierIdHalf = betterHalfs[0].baseModifierId;
          item.selectedSizesHalf = betterHalfs[0].selectedSizes;
          item.selectedModifiersHalf = betterHalfs[0].selectedModifiers;
          item.removedIngredientsHalf = betterHalfs[0].removedIngredients;
          item.selectedIngredientsHalf = betterHalfs[0].selectedIngredients;
          item.selectedExtraIngredientsHalf =
            betterHalfs[0].selectedExtraIngredients;
          items.push(item);
        }
      } else {
        items.push(item);
      }
      return item;
    });
  }
  return items;
};

const getMenuItems = (storeConfig, orderObj, halfHalfAdditionalCharges) => {
  let html = ``;
  let items = getItemGroupingsForReviewOrder(orderObj);
  items.forEach((item, index) => {
    !item.isHalf &&
      item.selectedSizes &&
      item.selectedSizes.forEach((size, index) => {
        html = html + `<tr class='item'>`;
        html = html + `<td>`;
        html =
          html +
          `${size.quantity} ${
            !item.itemType || item.itemType === 0
              ? `${size.name} ${item.name}`
              : `${size.name}${
                  size.cName && size.cName?.length > 0 ? `,${size.cName}` : ''
                } ${item.name}`
          } 
            ${
              size.variants
                ? size.variants.filter((f) => f.quantity > 0)?.length > 0
                  ? `(${size.variants
                      .filter((f) => f.quantity > 0)
                      .map((v) => v.name)
                      .join(',')})`
                  : ''
                : ''
            }  <br>`;

        item.selectedExtraIngredients &&
          item.selectedExtraIngredients.forEach((ingredient) => {
            html =
              html +
              `${`Extra ${
                ingredient.name ? ingredient.name : ingredient.ingredientName
              }`} <br>`;
          });

        item.removedIngredients &&
          item.removedIngredients.forEach((ingredient) => {
            html =
              html +
              `${`Remove ${
                ingredient.name ? ingredient.name : ingredient.ingredientName
              }`} <br>`;
          });

        html = html + `</td>`;

        html = html + `<td>`;

        let mainPrice =
          item.selectedExtraIngredients &&
          item.selectedExtraIngredients?.length > 0
            ? `${storeConfig.currency}${getItemCustomizedPriceOnly(
                item,
                size,
                halfHalfAdditionalCharges
              )}`
            : `${`${storeConfig.currency}${getItemCustomizedPrice(
                item,
                size,
                halfHalfAdditionalCharges
              )}`}`;

        html = html + mainPrice;

        let price =
          item.selectedExtraIngredients &&
          item.selectedExtraIngredients?.length > 0
            ? getExtraPrices(storeConfig, item, size)
            : ``;

        html = html + price;
        html = html + `</td>`;

        html = html + `</tr>`;
      });

    item.isHalf &&
      item.selectedSizes &&
      item.selectedSizes.forEach((size, index) => {
        html = html + `<tr class='item'>`;
        html = html + `<td>`;
        html =
          html +
          `${`${size.quantity * 2} 
            ${
              !item.itemType || item.itemType === 0
                ? `${size.name}`
                : `${size.name} ${
                    size.cName && size.cName?.length > 0 ? `,${size.cName}` : ''
                  }`
            }
            /
            ${
              !item.itemTypeHalf || item.itemTypeHalf === 0
                ? `${item.selectedSizesHalf
                    .filter((s) => Number(s.quantity) > 0)
                    .map((m) => m.name)
                    .join(' ')}`
                : `${item.selectedSizesHalf
                    .filter((s) => Number(s.quantity) > 0)
                    .map((m) => m.name)
                    .join(' ')} ${item.selectedSizesHalf
                    .filter((s) => Number(s.quantity) > 0)
                    .map((m) => m.cName)
                    .join(' ')}`
            } 
            ${item.name}/${item.nameHalf}  ${
            size.variants
              ? size.variants.filter((f) => f.quantity > 0)?.length > 0
                ? `(${size.variants
                    .filter((f) => f.quantity > 0)
                    .map((v) => v.name)
                    .join(',')})`
                : ''
              : ''
          } <br>`}`;

        (item.selectedExtraIngredients &&
          item.selectedExtraIngredients?.length > 0) ||
        (item.removedIngredients && item.removedIngredients?.length > 0)
          ? (html = html + `${item.name}<br>`)
          : (html = html);

        item.selectedExtraIngredients &&
          item.selectedExtraIngredients.forEach((ingredient) => {
            html =
              html +
              `${`Extra ${
                ingredient.name ? ingredient.name : ingredient.ingredientName
              }`} <br>`;
          });

        item.removedIngredients &&
          item.removedIngredients.forEach((ingredient) => {
            html =
              html +
              `${`Remove ${
                ingredient.name ? ingredient.name : ingredient.ingredientName
              }`} <br>`;
          });

        (item.selectedExtraIngredientsHalf &&
          item.selectedExtraIngredientsHalf?.length > 0) ||
        (item.removedIngredientsHalf && item.removedIngredientsHalf?.length > 0)
          ? (html = html + `${item.nameHalf}<br>`)
          : (html = html);

        item.selectedExtraIngredientsHalf &&
          item.selectedExtraIngredientsHalf.forEach((ingredient) => {
            html =
              html +
              `${`Extra ${
                ingredient.name ? ingredient.name : ingredient.ingredientName
              }`} <br>`;
          });

        item.removedIngredientsHalf &&
          item.removedIngredientsHalf.forEach((ingredient) => {
            html =
              html +
              `${`Remove ${
                ingredient.name ? ingredient.name : ingredient.ingredientName
              }`} <br>`;
          });

        html = html + `</td>`;

        html = html + `<td>`;

        if (
          item.selectedExtraIngredients &&
          item.selectedExtraIngredients?.length > 0
        ) {
          let mainPrice =
            item.selectedExtraIngredients &&
            item.selectedExtraIngredients?.length > 0
              ? `${storeConfig.currency}${getItemCustomizedPriceOnly(
                  item,
                  size,
                  halfHalfAdditionalCharges
                )}`
              : `${`${storeConfig.currency}${getItemCustomizedPrice(
                  item,
                  size,
                  halfHalfAdditionalCharges
                )}`}`;

          html = html + mainPrice;

          html = html + `<br><br>`;

          html = html + getExtraPricesForHalf(storeConfig, item, size);
        } else {
          if (
            item.selectedExtraIngredients &&
            item.selectedExtraIngredients?.length === 0
          ) {
            // html =
            //   html +
            //   `${`${storeConfig.currency}${getItemCustomizedPrice(
            //     item,
            //     size,
            //     halfHalfAdditionalCharges
            //   )}`}`;
          }
        }

        if (
          item.selectedExtraIngredientsHalf &&
          item.selectedExtraIngredientsHalf?.length > 0
        ) {
          let mainPriceExtra =
            item.selectedExtraIngredientsHalf &&
            item.selectedExtraIngredientsHalf?.length > 0
              ? `${storeConfig.currency}${getItemCustomizedPriceOnly(
                  item,
                  size,
                  halfHalfAdditionalCharges
                )}`
              : `${`${storeConfig.currency}${getItemCustomizedPrice(
                  item,
                  size,
                  halfHalfAdditionalCharges
                )}`}`;

          //html = html + mainPriceExtra;

          html = html + `<br><br>`;

          //html = html + getExtraPricesForHalf(item, size);
        } else {
          if (
            item.selectedExtraIngredientsHalf &&
            item.selectedExtraIngredientsHalf?.length === 0
          ) {
            html =
              html +
              `${`${storeConfig.currency}${getItemCustomizedPrice(
                item,
                size,
                halfHalfAdditionalCharges
              )}`}`;
          }
        }

        // html =
        //   html + `${`${storeConfig.currency}${getItemCustomizedPrice(item, size, halfHalfAdditionalCharges)}`}`;

        html = html + `</td>`;

        html = html + `</tr>`;
      });
  });

  return html;
};

const getAllSpecials = (storeConfig, orderObj) => {
  return `<tr class='item'><td>Specials</td><td> - ${storeConfig.currency}${orderObj.specialDiscount}</td>`;
};

const getGST = (storeConfig, orderObj) => {
  return `<tr class='item'><td>GST ${
    orderObj.isPriceIncludesGST ? '(*included in item prices)' : ''
  }</td><td>  ${storeConfig.currency}${orderObj.gst}</td>`;
};

const getCreditCardCharges = (storeConfig, orderObj) => {
  const { cardChargesTitle, cardCharges } = getPlatformAndCardCharges(orderObj);
  return `<tr class='item'><td>${cardChargesTitle}</td><td>  ${storeConfig.currency}${cardCharges}</td>`;
};

const getRewards = (storeConfig, orderObj) => {
  return `<tr class='item'><td>Loyalty</td><td> - ${storeConfig.currency}${orderObj.loyaltyDiscount}</td>`;
};

const getSurcharge = (storeConfig, orderObj) => {
  return `<tr class='item'><td>Public Holiday Surcharge (${orderObj.publicHolidaySurchargePer}%)</td><td>  ${storeConfig.currency}${orderObj.publicHolidaySurcharge}</td>`;
};

const getVouchers = (storeConfig, orderObj) => {
  return `<tr class='item'><td>Voucher</td><td> - ${storeConfig.currency}${orderObj.voucherDiscount}</td>`;
};

const getDelivery = (storeConfig, orderObj) => {
  return `<tr class='item'><td>Delivery Fee</td><td>${
    storeConfig.currency
  }${Number(orderObj.deliveryCost).toFixed(2)}</td>`;
};

const template = (orderObj, storeConfig, halfHalfAdditionalCharges) => {
  let totalAmount = Number(orderObj.payableAmount);
  if (orderObj?.isPlatformSurchargeLevied) {
    totalAmount = totalAmount + Number(orderObj?.platformSurchargeAmt || 0);
  }
  totalAmount = totalAmount?.toFixed(2);
  return `<!doctype html>
  <html>
  <head>
      <meta charset="utf-8">
      <title>Invoice-${storeConfig.name}-${orderObj.deliveryCode}</title>
      
      <style>
      .invoice-box {
          max-width: 800px;
          margin: auto;
          padding: 30px;
          border: 1px solid #eee;
          box-shadow: 0 0 10px rgba(0, 0, 0, .15);
          font-size: 16px;
          line-height: 24px;
          font-family: var(--old-font-HelveticaNeue);
          color: #555;
      }
      
      .invoice-box table {
          width: 100%;
          line-height: inherit;
          text-align: left;
      }
      
      .invoice-box table td {
          padding: 5px;
          vertical-align: top;
      }
      
      .invoice-box table tr td:nth-child(2) {
          text-align: right;
      }
      
      .invoice-box table tr.top table td {
          padding-bottom: 20px;
      }
      
      .invoice-box table tr.top table td.title {
          font-size: 45px;
          line-height: 45px;
          color: #333;
      }
      
      .invoice-box table tr.information table td {
          padding-bottom: 40px;
      }
      
      .invoice-box table tr.heading td {
          background: #eee;
          border-bottom: 1px solid #ddd;
          font-weight: var(--old-font-bold);
          letter-spacing: calc(var(--current-tracking-HelveticaNeue) - var(--tracking-offset-HelveticaNeue-bold, 0em));
      }
      
      .invoice-box table tr.details td {
          padding-bottom: 20px;
      }
      
      .invoice-box table tr.item td{
          border-bottom: 1px solid #eee;
      }
      
      .invoice-box table tr.item.last td {
          border-bottom: none;
      }
      
      .invoice-box table tr.total td:nth-child(2) {
          border-top: 2px solid #eee;
          font-weight: var(--old-font-bold);
          letter-spacing: calc(var(--current-tracking-HelveticaNeue) - var(--tracking-offset-HelveticaNeue-bold, 0em));
      }
      
      @media only screen and (max-width: 600px) {
          .invoice-box table tr.top table td {
              width: 100%;
              display: block;
              text-align: center;
          }
          
          .invoice-box table tr.information table td {
              width: 100%;
              display: block;
              text-align: center;
          }
      }
      
      /** RTL **/
      .rtl {
          direction: rtl;
          font-family: var(--old-font-Tahoma);
      }
      
      .rtl table {
          text-align: right;
      }
      
      .rtl table tr td:nth-child(2) {
          text-align: left;
      }
      </style>
  </head>
  
  <body>
      <div class="invoice-box">
          <table cellpadding="0" cellspacing="0">
              <tr class="top">
                  <td colspan="2">
                      <table>
                          <tr>
                              <td class="title">
                                  <img src=${
                                    storeConfig.logo
                                  } style="width:100%; max-width:300px;">
                              </td>
                              
                              <td>
                              Order Date: ${moment(
                                orderObj.deliveryDate
                              ).format('Do MMM YYYY, h:mm A ')}<br>
                                Invoice Id: ${orderObj._id}<br>
                                Order Id: ${orderObj.deliveryCode}<br>
                                ${
                                  storeConfig.businessNumber
                                    ? `ABN : ${storeConfig.businessNumber}<br>`
                                    : `<br />`
                                }
                              </td>
                          </tr>
                      </table>
                  </td>
              </tr>
              
              <tr class="information">
                  <td colspan="2">
                      <table>
                          <tr>
                              <td>
                              ${storeConfig.name}<br>
                                  ${storeConfig.address}<br>
                                  ${storeConfig.city}, ${
    storeConfig.stateIdentifier
  }<br>
                                  ${storeConfig.phoneNumberDisplay}
                              </td>
                              
                              <td>
                                  ${orderObj.firstName} ${orderObj.lastName}<br>
                                  ${orderObj.mobileNumber}<br>
                              </td>
                          </tr>
                      </table>
                  </td>
              </tr>
              
              <tr class="heading">
                  <td>
                      Payment Method
                  </td>
                  
                  <td>
                      Amount
                  </td>
              </tr>
              
              <tr class="details">
                  <td>
                      ${
                        orderObj.paymentType === ORDER_PAYMENT_TYPE.cash
                          ? 'Cash'
                          : 'Card'
                      }
                  </td>
                  
                  <td>
                      ${storeConfig.currency}${totalAmount}
                  </td>
              </tr>
              
              <tr class="heading">
                  <td>
                      Item
                  </td>
                  
                  <td>
                      Price
                  </td>
              </tr>
              
              ${getMenuItems(storeConfig, orderObj, halfHalfAdditionalCharges)}

              ${
                orderObj.publicHolidaySurcharge &&
                Number(orderObj.publicHolidaySurcharge) !== 0
                  ? getSurcharge(storeConfig, orderObj)
                  : ``
              }
              ${
                orderObj.rewards?.length > 0
                  ? getRewards(storeConfig, orderObj)
                  : ``
              }
              ${
                orderObj.specials?.length > 0
                  ? getAllSpecials(storeConfig, orderObj)
                  : ``
              }
              ${
                orderObj.voucherId !== '' && orderObj.voucherDiscount !== 0
                  ? getVouchers(storeConfig, orderObj)
                  : ``
              }
              ${orderObj.isDisplayGST ? getGST(storeConfig, orderObj) : ``}
              ${
                orderObj.creditCardCharges && Number(orderObj.creditCardCharges)
                  ? getCreditCardCharges(storeConfig, orderObj)
                  : ``
              }
              ${
                orderObj.address !== '' && orderObj.deliveryCost > 0
                  ? getDelivery(storeConfig, orderObj)
                  : ``
              }

              <tr class="total">
              <td style="
              border-top: 2px solid #eee;
              font-weight:  var(--old-font-bold);"></td>
                  
                  <td>
                     Total: ${storeConfig.currency}${totalAmount}
                  </td>
              </tr>
          </table>
      </div>
  </body>
  </html>`;
};

export default template;
